import { CircularProgress } from '@mui/material'
import MaterialUIButton, { ButtonProps } from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import * as React from 'react'

const FloatingCircularProgress = styled(CircularProgress)({
  left: '50%',
  marginLeft: -12,
  marginTop: -12,
  position: 'absolute',
  top: '50%',
})

const Button = <C extends React.ElementType>({
  children,
  isLoading,
  ...buttonProps
}: ButtonProps<C, { component?: C; isLoading?: boolean }>) => {
  return (
    <MaterialUIButton {...buttonProps} disabled={isLoading || buttonProps.disabled}>
      {children}
      {isLoading && <FloatingCircularProgress size={24} />}
    </MaterialUIButton>
  )
}

export default Button
